/* eslint-disable */
import "common/cable";

const SELECTORS = {
  SPINNER: ".js-delivery-date-estimates-comparable-spinner",
  WRAPPER: ".js-comparable-delivery-date-wrapper",
  DATE: ".js-comparable-delivery-date",
  JIFFY_FIRST_ICON: ".js-comparable-delivery-date-j1",
};

/* eslint-disable camelcase */
export default (connectionId, compositionIds) => {
  const params = {
    channel: "Assignments::ComparablesDatesChannel",
    connection_id: connectionId,
    composition_ids: compositionIds
  };
  const { App } = window;
  window.comparablesCompositionIdsSent = [];

  // eslint-disable-next-line no-undef
  App.comparablesDatesChannel = App.cable.subscriptions.create(params, {
    connected() {
      window.comparablesCompositionIdsSent = [];
    },

    send(data) {
      window.comparablesCompositionIdsSent = window.comparablesCompositionIdsSent.concat(
        data.composition_ids
      );

      return this.consumer.send({
        command: "message",
        identifier: this.identifier,
        data: JSON.stringify(data)
      });
    },

    received: function(data) {
      const {
        clean,
        composition_id: composition,
        composition_dates: compositionDates,
        cart_dates: cartDates
      } = data;

      const $parents = document.querySelectorAll(
        `.js-delivery-date-estimates-comparables-wrapper[data-composition-id="${composition}"]`
      );

      $parents.forEach($parent => {
        if (clean) {
          $parent.classList.toggle("hide-children", true);

          return;
        }

        const showLogo = cartDates?.first_full ? cartDates.show_logo : compositionDates.show_logo;
        const date = cartDates?.first_full ? cartDates.first_full : compositionDates.first_full;

        $parent.querySelector(SELECTORS.DATE).innerHTML = date;
        if (showLogo) {
          $parent.querySelector(SELECTORS.JIFFY_FIRST_ICON).classList.toggle("hidden", false);
        }

        $parent.querySelector(SELECTORS.WRAPPER).classList.toggle("hidden", false);
        $parent.querySelector(SELECTORS.SPINNER).classList.toggle("hidden", true);
      });
    }
  });
};
/* eslint-enable camelcase */
